<template>
    <v-container>
        <v-row>
            <v-card width="100%" class="mx-1">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-card class="mt-4">
            <v-card-title class="primary">
                <v-toolbar-title id="titulocard">Buscar URL Acortada</v-toolbar-title>
            </v-card-title>
            <v-card-text>
                <v-form lazy-validation ref="formreporte">
                    <v-row justify="center">
                        <v-col cols="12" md="7">
                            <v-row>
                                <v-col cols="12" md="6">
                                    <span style="font-weight: bold;">Short Code:</span>
                                    <v-text-field v-model="busqueda.url" outlined width="20px" dense maxlength="7"
                                        :rules="rules"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <span style="font-weight: bold;"> Sitio: </span>
                                    <multiselect v-model="busqueda.ntsitio" :options="Sitio.CatalogoSitios"
                                        selected-label="Seleccionado" select-label="Seleccione un sitio"
                                        track-by="saclave" label="sitio" placeholder="Seleccione un sitio"
                                        :allow-empty="true" :close-on-select="false"
                                        deselect-label="Deseleccione el sitio">
                                    </multiselect>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>
        <v-card v-if="show" class="mt-2">
            <v-card-text>
                <v-row justify="center">
                    <v-col cols="12">
                        <DataTable class="tablaAcortador" :url="url" :columns="columnasNotificacion"
                            :params="displayInputs" @apiDT="apiDT = $event" :order="[]"
                            :formatterActions="formatterActions" @Cancelar="CancelarShow">
                        </DataTable>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { mapState } from "vuex";
import Menu from '@/components/pages/Sistemas/MenuSistemas.vue';
import Sistemas from "@/services/Sistemas/sistemas.service.js";
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import DataTable from "@/components/pages/DataTableNet/DataTable";

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        Menu,
        DataTable,
    },
    data: function () {
        return {
            Sitio: {
                CatalogoSitios: [],
                ntsitio: '',
            },
            busqueda: {
                url: null,
                ntsitio: null
            },
            show: false,
            permisoSistemas: false,
            url: "Sistemas/BusquedaAcortador",
            displayInputs: {
                url: null,
                ntsitio: null,
            },
            columnasNotificacion: [
                { name: 'Short Code', data: 'tinyUrl', title: "Short Code", formatter: [this, "DetalleStyle"] },
                { name: 'URL Acortada', data: 'short', title: "URL Acortada" },
                { name: 'URL Completa', data: 'longUrl', title: "URL Completa" },
                { name: 'Visitas', data: 'visitas', title: "Visitas" },
                { name: 'Fecha Alta', data: 'afhalta', title: "Fecha Alta" },
                { name: 'Usuario', data: 'uslogin', title: "Usuario" },
                { name: 'Eliminar', data: 'aclave', title: "Eliminar", formatter: [this, "EliminarStyle"], orderable: false },
            ],
            apiDT: null,
            formatterActions: [
                { click: [this, "Eliminar"] },
                { click: [this, "DetalleAcortador"] }
            ],
            rules: [v => (!v || v.length > 2) || 'Agregue más de 2 caracteres',],
            cargando: false,

        }
    },
    computed: {
        ...mapState(["domain", "informationPage", "permission"]),
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '60').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 60)//Permiso para Sistemas
                        this.permisoSistemas = true;
                });
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    },
    async mounted() {
        await Sistemas.CatalogoAcortador(this);
    },
    watch: {
        'busqueda.url'(val) {
            if (val.trim().length >= 3) {
                this.Buscar();
            } else {
                this.show = false;
            }
            if (val == '' && this.busqueda.ntsitio != null) {
                this.Buscar();
            }
        },
        'busqueda.ntsitio'(val) {
            if (val != null) {
                this.Buscar();
            } else if (val == null && (this.busqueda.url == '' || this.busqueda.url == null)) {
                this.show = false;
            }
        }
    },
    methods: {
        CancelarShow() {
            this.cargando = false;
        },
        EliminarStyle(datos) {
            return datos.aclave ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small secondary dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${datos.aclave}" title="Eliminar" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-delete theme--dark"></i></span></button></div>` : ``;
        },
        DetalleStyle(datos) {
            return `<button data-action="1" data-params="${datos.aclave}" class="dt-formatterAction ma-1 reporteindice">${datos.tinyUrl}</span></button>`;
        },
        async Buscar() {
            this.show = true;
            this.displayInputs = {
                url: this.busqueda.url,
                ntsitio: this.busqueda.ntsitio != null ? this.busqueda.ntsitio.saclave : null,
            }
            await this.reloadTable();
        },
        async reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },
        async Eliminar(params, datos, fila) {
            this.$swal({
                position: "center",
                icon: "info",
                text: "¿Está seguro que desea eliminar esta URL Acortada?",
                showCancelButton: true,
                confirmButtonColor: '#536DFE',
                cancelButtonColor: '#FF5C93',
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$swal({
                        title: 'Eliminando URL, espere, por favor.',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: async () => {
                            this.$swal.showLoading();
                            let resp = await Sistemas.EliminarURLAcortada(datos.aclave);
                            if (resp == true) {
                                this.$swal({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Éxito',
                                    text: 'URL Acortada eliminada correctamente',
                                    showConfirmButton: true,
                                    confirmButtonColor: '#536DFE',
                                    confirmButtonText: 'Aceptar',
                                    allowOutsideClick: false,
                                    timer: 2500,
                                }).then(async () => {
                                    this.reloadTable();
                                });

                            } else {
                                this.$swal({
                                    position: 'center',
                                    icon: 'warning',
                                    title: 'Error',
                                    text: 'Ocurrió un error al eliminar la URL, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                    showConfirmButton: false,
                                    timer: 2500
                                });
                            }
                        },
                    });
                }
            });
        },
        async DetalleAcortador(params, datos) {
            let acortador = {
                sitio: datos.saclave,
                short: datos.short,
                longUrl: datos.longUrl,
                aclave: datos.aclave
            };
            await MetodosGenerales.guardarEnSesionInfoReporte(acortador, 'acortador');
            this.$router.push({ name: 'DetalleAcortador' });
        }

    }
}
</script>

<style></style>